import { createSlice } from "@reduxjs/toolkit";
import { getEvidenceViewList } from "./thunk";

const getEvidenceSlice = createSlice({
    name: "getEvidenceViewList",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getEvidenceViewList.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getEvidenceViewList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getEvidenceViewList.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

    }
});

export default getEvidenceSlice.reducer;